module.exports = __webpack_public_path__ + "static/media/haltian-logo.f4c584be.png";